/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Like: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.59394 5.63767C5.73097 3.45411 9.20488 3.45411 11.3419 5.63767L12 6.31009L12.6581 5.63767C14.7951 3.45411 18.269 3.45411 20.4061 5.63767C22.5313 7.80921 22.5313 11.3212 20.4061 13.4928C20.396 13.5031 20.3856 13.5132 20.3751 13.523L12.6837 20.7297C12.2991 21.0901 11.7009 21.0901 11.3163 20.7297L3.62488 13.523C3.61435 13.5132 3.60404 13.5031 3.59394 13.4928C1.46869 11.3212 1.46869 7.80921 3.59394 5.63767L4.30862 6.33712L3.59394 5.63767ZM9.91254 7.03657C8.5599 5.65448 6.37595 5.65448 5.02331 7.03657C3.66364 8.42585 3.65891 10.684 5.00913 12.0793L12 18.6296L18.9909 12.0793C20.3411 10.684 20.3364 8.42584 18.9767 7.03657L19.6914 6.33712L18.9767 7.03657C17.6241 5.65448 15.4401 5.65448 14.0875 7.03657L12.7147 8.43924C12.5266 8.63145 12.2689 8.73979 12 8.73979C11.731 8.73979 11.4734 8.63145 11.2853 8.43924L9.91254 7.03657Z'
      fill='currentColor'
    />
  </React.Fragment>
)
